import { render, staticRenderFns } from "./NPSComponent.vue?vue&type=template&id=57beab34"
import script from "./NPSComponent.vue?vue&type=script&lang=ts"
export * from "./NPSComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports